/* ===========================
IMPORTS
=========================== */
import React from 'react';
import PropTypes from 'prop-types';
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class ModalDelete extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
  * Main constructor of Component
  * @param {object} props
  */
  constructor(props) {
    super(props);

    this.state = {
      errors: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  /**
  * componentDidMount
  */
  componentDidMount() {
    this.props.updateLoadingModal(false);
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   * @param {Event} event
   */
  handleSubmit(event) {
    this.props.handleSubmit(true);
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/bundles/${this.props.data.id}`,
      'delete',
      null,
      // callback
      () => {
        this.props.handleSubmitSuccess();
      },
      // failback
      (error) => {
        this.setState({
          errors: (error || 'Something went wrong.'),
        }, () => {
          this.props.handleSubmit(false);
        });
      },
    );

    event.preventDefault();
  }

  /**
   * @param {Event} event
   */
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div>
        {(!this.props.loading)
          ? (
            <form id={this.props.id} onSubmit={this.handleSubmit}>
              {(this.state.errors && Object.keys(this.state.errors).length > 0)
                ? (
                  <div className="form-group">
                    <div className="alert alert-danger">
                      <ul>
                        {(Object.keys(this.state.errors).map((item) => (
                          <li key={`list-${item}`}>
                            <strong>{item}</strong>
                            {' '}
                            -
                            {' '}
                            {this.state.errors[item]}
                          </li>
                        )))}
                      </ul>
                    </div>
                  </div>
                )
                : null}

              {(this.props.submitted)
                ? (<Loader />)
                : null}

              <button type="submit" aria-label="submit" style={{ display: 'none' }} disabled={this.props.submitted} />
            </form>
          )
          : null}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
ModalDelete.propTypes = {
  id: PropTypes.string,
  data: PropTypes.object,
  loading: PropTypes.bool,
  submitted: PropTypes.bool,
  updateLoadingModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleSubmitSuccess: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default ModalDelete;
